import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "aria-label"]

import { toRefs } from 'vue';

// Personal
import { programmaticFocus } from './util';

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'VueSkipToSingle',
  props: {
  label: { required: true, type: String, default: 'Aller au contenu' },
  ariaLabel: { required: true, type: String, default: 'Aller au contenu' },
  anchor: { required: true, type: String, default: '#main' },
},
  emits: ['focused'],
  setup(__props, { emit: __emit }) {

// Vendor
const emits = __emit;
/**
 * Properties
 */
const properties = __props;
const { label, anchor } = toRefs(properties);

/**
 * Datas
 */
const focusedTags = new RegExp('^(a|select|input|button|textarea)', 'i');

/**
 * Methods
 */
function focusElement(id: string) {
  if (!id) return;

  const newId = id.startsWith('#') ? id.slice(1) : id;

  const element = window.document.getElementById(newId);
  if (!element) return;

  if (!focusedTags.test(element.tagName.toLowerCase())) {
    emits('focused', false);
    return programmaticFocus(element);
  }
  element.focus();
  emits('focused', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _unref(anchor),
    "aria-label": __props.ariaLabel,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (focusElement(_unref(anchor))), ["prevent"])),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focused', true))),
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focused', false))),
    class: "vue-skip-to__link"
  }, _toDisplayString(_unref(label)), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})